import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "./assets/locales/en/translation.json";
import translationDE from "./assets/locales/de/translation.json";
import translationES from "./assets/locales/es/translation.json";

// Client Translation Files (variations on 'en', usually)
import translation_sfvpallet from "./assets/locales/sfvpallet/translation.json";
import translation_arbortrace from "./assets/locales/arbor-trace/translation.json";

const fallbackLng = ["en"];
export const availableLanguages = ["en", "de", "es", "sfvpallet", "arbor-trace"];

const resources = {
  en: {
    translation: translationEN
  },
  de: {
    translation: translationDE
  },
  es: {
    translation: translationES
  },
  "sfvpallet": {
    translation: translation_sfvpallet
  },
  "arbor-trace": {
    translation: translation_arbortrace
  }
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng,
    lowerCaseLng: true,

    detection: {
      checkWhitelist: true
    },

    debug: false,


    whitelist: availableLanguages,

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
